// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mySlides {display: none}


.image {
    vertical-align: middle;
    width: 30rem ;
}

/* Slideshow container */
.slideshow-container {
  max-width: 1000px;
  position: relative;
  margin: auto;
}

/* Next & previous buttons */
.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -22px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  -webkit-user-select: none;
          user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little   t see-through */
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}
.photo {
    color: #f2f2f2;
    font-size: 20px;
    padding: 8px 12px;
    position: absolute;
    right:0;
  }

  .photo-delete {
    color: #f2f2f2;
    font-size: 20px;
    padding: 8px 12px;
    position: absolute;
    right:0;
    top:10%;
  }

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active, .dot:hover {
  background-color: #717171;
}

/* Fading animation */
.fade {
  animation-name: fade;
  animation-duration: 1.5s;
}

@keyframes fade {
  from {opacity: .4} 
  to {opacity: 1}
}

/* On smaller screens, decrease text size */
@media only screen and (max-width: 300px) {
  .prev, .next,.text {font-size: 11px}
}

 .customImage {
  display: flex;
  overflow: scroll  ;
  
}
.customImage div {
  min-width: 150px;
  width:100%;
}`, "",{"version":3,"sources":["webpack://./src/components/imageSlider/imageslider.css"],"names":[],"mappings":"AAAA,WAAW,aAAa;;;AAGxB;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,QAAQ;EACR,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;AACR;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,OAAO;EACT;;AAEF,gCAAgC;AAChC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,MAAM,WAAW;EACjB,IAAI,UAAU;AAChB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB,eAAe;AACrC;;CAEC;EACC,aAAa;EACb,kBAAkB;;AAEpB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":[".mySlides {display: none}\n\n\n.image {\n    vertical-align: middle;\n    width: 30rem ;\n}\n\n/* Slideshow container */\n.slideshow-container {\n  max-width: 1000px;\n  position: relative;\n  margin: auto;\n}\n\n/* Next & previous buttons */\n.prev, .next {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  padding: 16px;\n  margin-top: -22px;\n  color: white;\n  font-weight: bold;\n  font-size: 18px;\n  transition: 0.6s ease;\n  border-radius: 0 3px 3px 0;\n  user-select: none;\n}\n\n/* Position the \"next button\" to the right */\n.next {\n  right: 0;\n  border-radius: 3px 0 0 3px;\n}\n\n/* On hover, add a black background color with a little   t see-through */\n.prev:hover, .next:hover {\n  background-color: rgba(0,0,0,0.8);\n}\n\n/* Caption text */\n.text {\n  color: #f2f2f2;\n  font-size: 15px;\n  padding: 8px 12px;\n  position: absolute;\n  bottom: 8px;\n  width: 100%;\n  text-align: center;\n}\n\n/* Number text (1/3 etc) */\n.numbertext {\n  color: #f2f2f2;\n  font-size: 12px;\n  padding: 8px 12px;\n  position: absolute;\n  top: 0;\n}\n.photo {\n    color: #f2f2f2;\n    font-size: 20px;\n    padding: 8px 12px;\n    position: absolute;\n    right:0;\n  }\n\n  .photo-delete {\n    color: #f2f2f2;\n    font-size: 20px;\n    padding: 8px 12px;\n    position: absolute;\n    right:0;\n    top:10%;\n  }\n\n/* The dots/bullets/indicators */\n.dot {\n  cursor: pointer;\n  height: 15px;\n  width: 15px;\n  margin: 0 2px;\n  background-color: #bbb;\n  border-radius: 50%;\n  display: inline-block;\n  transition: background-color 0.6s ease;\n}\n\n.active, .dot:hover {\n  background-color: #717171;\n}\n\n/* Fading animation */\n.fade {\n  animation-name: fade;\n  animation-duration: 1.5s;\n}\n\n@keyframes fade {\n  from {opacity: .4} \n  to {opacity: 1}\n}\n\n/* On smaller screens, decrease text size */\n@media only screen and (max-width: 300px) {\n  .prev, .next,.text {font-size: 11px}\n}\n\n .customImage {\n  display: flex;\n  overflow: scroll  ;\n  \n}\n.customImage div {\n  min-width: 150px;\n  width:100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
